import axios from 'axios';
import toast from 'react-hot-toast';

const WAREHOUSE_KEY = 'activeWarehouseId';
const CLIENT_KEY = 'activeClientId';

// When REACT_APP_API_URL is set (production builds) it wins. Otherwise requests
// stay relative to whatever host served the page, and src/setupProxy.js forwards
// them to the API. That makes localhost and the host PC's LAN IP both work over
// a single port, with no cross-origin request to negotiate.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const warehouseId = localStorage.getItem(WAREHOUSE_KEY);
  if (warehouseId) config.headers['x-warehouse-id'] = warehouseId;

  const clientId = localStorage.getItem(CLIENT_KEY);
  if (clientId) config.headers['x-client-id'] = clientId;

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const wasSignedIn = !!localStorage.getItem('token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (wasSignedIn && window.location.pathname !== '/login') {
        toast.error(err.response?.data?.message || 'Your session has ended. Please sign in again.');
      }
      window.location.href = '/login';
    }
    if (
      err.response?.status === 403 &&
      err.response?.data?.mustChangePassword &&
      window.location.pathname !== '/change-password'
    ) {
      window.location.href = '/change-password';
    }
    return Promise.reject(err);
  }
);

export default api;
